import { render, staticRenderFns } from "./BrandResponsiveCard.vue?vue&type=template&id=486f96fe"
import script from "./BrandResponsiveCard.vue?vue&type=script&lang=js"
export * from "./BrandResponsiveCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports